import { Component, Input } from "@angular/core";
import {
    GetESGMatrixResponse,
} from "../../../WebApiClient";
import { ComponentBase } from "../../../models/ComponentBase";

@Component({
    selector: "app-sustainability-esg-matrix",
    templateUrl: "./sustainability-matrix.component.html",
    styleUrls: [
        "./sustainability-matrix.component.scss"
    ],
    standalone: false
})
export class SustainabilityMatrixComponent
    extends ComponentBase
{
    @Input()
    esgMatrixData: GetESGMatrixResponse | undefined;

    constructor() {
        super();
    }
}
